<template>
    <page-controls>
        <template v-slot:left>
            <div class="grow @3xl/controls:max-w-md">
                <vx-filterable :active="active"
                    @toggle="toggleFilterable">
                    <template v-slot:placeholder>
                        <span class="mr-2">Find custom attributes</span>
                        <vx-badge v-if="filtersCount > 0"
                            :borders="false"
                            size="xs"
                            @click.stop="reset">
                            {{ pluralized('filter', filtersCount, true )}}
                            <font-awesome-icon widthAuto :icon="faCircleXmark" />
                        </vx-badge>
                    </template>
                    <template v-slot:form>
                        <form @submit.prevent="active = false; emit('apply')"
                            class="space-y-4">
                            <div class="space-y-1">
                                <filter-label :canReset="!!props.modelValue.query" @reset="updateModelValue('query', undefined)">
                                    Keyword Search
                                </filter-label>

                                <vx-input
                                    type="text"
                                    placeholder="Find custom attributes"
                                    :modelValue="props.modelValue.query"
                                    maxlength="80"
                                    size="lg"
                                    @update:modelValue="updateModelValue('query', $event)">
                                    <template v-slot:right>
                                        <font-awesome-icon widthAuto class="text-xs"
                                            :icon="faMagnifyingGlass" />
                                    </template>
                                </vx-input>
                            </div>

                            <div class="flex gap-2 pt-4">
                                <vx-button type="button"
                                    size="lg"
                                    color="muted-light"
                                    @click="active = false; reset()">Cancel</vx-button>
                                <vx-button data-test="filters-apply"
                                    size="lg"
                                    type="submit"
                                    block>
                                    Apply
                                    <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
                                </vx-button>
                            </div>
                        </form>
                    </template>
                </vx-filterable>
            </div>
        </template>
        <template v-slot:right>
            <vx-button class="w-full"
                color="muted-dark"
                size="lg"
                @click="informationModal = true">
                <span class="block @3xl/controls:hidden">Overview</span>
                <font-awesome-icon widthAuto :icon="faCircleQuestion" />
            </vx-button>

            <vx-modal v-model:visible="informationModal"
                class="max-w-lg">
                <template v-slot:header>Custom Attributes</template>
                <p class="mb-2 text-base">
                    Contact Custom Attributes apply to individual contacts. These Custom Attributes contain specific
                    identifying information about your contacts, building up your audience profiling. The Contact Custom
                    Attributes can be used in Segments to target or group a certain audience with similar interests for
                    Campaigns and in messages directly to personalize the message to an individual contact.
                </p>
            </vx-modal>
        </template>
    </page-controls>
</template>
<script setup>
import { faCircleCheck, faCircleQuestion, faMagnifyingGlass, faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxBadge, VxModal, VxFilterable, VxInput } from '@voxie/frontend-components';
import { ref, computed } from 'vue';
import PageControls from '~/components/general/PageControls.vue';
import FilterLabel from '~/components/general/FilterLabel.vue';
import { pluralized } from '~/components/filters';

const informationModal = ref(false);
const active = ref(false);

const toggleFilterable = (event) => {
    active.value = event;
}

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
});


const emit = defineEmits(['update:modelValue', 'apply', 'reset'])

const updateModelValue = (key, value) => {
    emit("update:modelValue", {
        ...props.modelValue,
        [key]: value,
    });
};

const filtersCount = computed(() => (props.modelValue.query ? 1 : 0));

const reset = () => {
    emit('reset')
}
</script>
